import { render } from "./Home.vue?vue&type=template&id=fa0f1554&lang=pug"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script